import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { IdentifierEffects } from './identifier.effects';
import { reducer } from './identifier.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('identifier', reducer),
    EffectsModule.forFeature([IdentifierEffects]),
  ],
  providers: [IdentifierEffects],
})
export class IdentifierStoreModule {}
